import React from "react";
import { motion } from "framer-motion";
import {
  FaWhatsapp,
  FaLinkedinIn,
  FaGooglePlusG,
  FaInstagram,
  FaTelegramPlane,
  FaEnvelope,
} from "react-icons/fa" ;
import { TypeAnimation } from "react-type-animation";

// import "./homePage.css";
import { Helmet } from "react-helmet";

export default function HomePage() {
  const socialLinks = [
    { 
      icon: <FaWhatsapp />, 
      link: "https://wa.me/916393561379?text=Hello%20I'm%20looking%20for%20software%20development%20services.%20Please%20share%20details.", 
      name: "WhatsApp" 
    },
    { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/in/anmolsingh-chainmagicianlab", name: "LinkedIn" },
    { icon: <FaGooglePlusG />, link: "https://google.com", name: "Google" },
    { icon: <FaInstagram />, link: "https://instagram.com/chainmagicianlab", name: "Instagram" },
    { icon: <FaTelegramPlane />, link: "https://t.me/chainmagicianlab", name: "Telegram" },
    { icon: <FaEnvelope />, link: "mailto:connnect@chainmagicianlab.com", name: "Email" },
  ];

  // Simple fade animations
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const fadeIn = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <>
       <motion.section 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-white to-gray-50"
    >
      {/* Premium subtle background elements - more opaque */}
      {/* <motion.div 
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="absolute top-2/2 left-2/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gradient-to-r from-[#12AF09]/10 to-[#1b8a10]/10 rounded-full blur-[100px]"
      /> */}

      {/* Finer, more elegant grid - static */}
      {/* <div className="absolute inset-0 bg-[linear-gradient(to_right,#d1d5db_1px,transparent_1px),linear-gradient(to_bottom,#d1d5db_1px,transparent_1px)] bg-[size:40px_40px] opacity-25"></div> */}

      {/* Accent grid lines in green - static */}
      {/* <div className="absolute inset-0 bg-[linear-gradient(to_right,#12AF09_1px,transparent_1px),linear-gradient(to_bottom,#12AF09_1px,transparent_1px)] bg-[size:80px_80px] opacity-10"></div> */}

      {/* Main content */}
      <motion.div 
        variants={staggerContainer}
        initial="initial"
        animate="animate"
        className="relative z-10 text-center px-3 max-w-7xl mx-auto"
      >
        {/* Title - refined typography */}
        <motion.h1 
  variants={fadeInUp}
  className="font-bold text-5xl md:text-7xl lg:text-8xl leading-[1.2]  tracking-tight mb-6 drop-shadow-[0_4px_24px_rgba(38,189,25,0.45)]"
>
  <motion.span 
    initial={{ opacity: 0, x: -20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ delay: 0.2, duration: 0.5 }}
    className="text-[#12AF09] md:drop-shadow-[1px_4px_0_rgba(0,0,0,0.20)]"
  >
    CHAIN
  </motion.span>
  {' '}
  <motion.span 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.3, duration: 0.5 }}
    className="  text-[#12AF09]  md:drop-shadow-[2px_4px_0_rgba(0,0,0,0.20)]"
  >
    MAGICIAN
  </motion.span>
  {' '}
  <motion.span 
    initial={{ opacity: 0, x: 20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ delay: 0.4, duration: 0.5 }}
    className="text-[#12AF09] md:drop-shadow-[2px_4px_0_rgba(0,0,0,0.20)]"
  >
    LAB
  </motion.span>
</motion.h1>

        {/* Subtitle with premium styling */}
        <motion.div 
          variants={fadeInUp}
          className="h-16 mb-12"
        >
          <TypeAnimation
            sequence={[
              "Magician Of Web3", 2000,
              "Magician Of Apps", 2000,
              "Magician Of IOT", 2000,
              "Magician Of AI", 2000,
              "Magician Of Blockchain", 2000,
              "Magician Of Software", 2000,
            ]}
            wrapper="p"
            speed={50}
            repeat={Infinity}
            className="text-lg md:text-2xl text-slate-800 font-medium tracking-wide"
          />
        </motion.div>

        {/* Premium separator */}
        <motion.div 
          variants={fadeIn}
          className="w-24 h-px bg-gradient-to-r from-transparent via-[#12AF09]/30 to-transparent mx-auto mb-12"
        />

        {/* Social Icons - refined design */}
        <motion.div 
          variants={staggerContainer}
          className="flex justify-center gap-4 md:gap-6 flex-wrap"
        >
          {socialLinks.map((item, index) => (
            <motion.a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              variants={fadeInUp}
              whileHover={{ 
                y: -4,
                transition: { duration: 0.2 }
              }}
              whileTap={{ scale: 0.95 }}
              className="group relative"
            >
              {/* Icon container */}
              <motion.div 
                whileHover={{ 
                  boxShadow: "0 20px 25px -5px rgba(38, 189, 25, 0.1), 0 10px 10px -5px rgba(38, 189, 25, 0.04)"
                }}
                className="w-14 h-14 flex items-center justify-center rounded-2xl 
                bg-white border border-gray-200 text-slate-800 text-xl
                shadow-lg shadow-gray-200/50
                hover:border-[#12AF09]/30
                hover:-translate-y-1
                transition-all duration-300 ease-out
                relative overflow-hidden
                before:absolute before:inset-0 before:bg-gradient-to-r before:from-[#12AF09]/0 before:to-[#12AF09]/0
                hover:before:from-[#12AF09]/5 hover:before:to-[#1b8a10]/5"
              >
                <motion.span 
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.5 }}
                  className="relative z-10 group-hover:text-[#12AF09] transition-colors duration-300"
                >
                  {item.icon}
                </motion.span>
              </motion.div>
              
              {/* Subtle tooltip on hover */}
              <motion.span 
                initial={{ opacity: 0, y: 5 }}
                whileHover={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
                className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-xs text-gray-400 whitespace-nowrap"
              >
                {item.name}
              </motion.span>
            </motion.a>
          ))}
        </motion.div>

        {/* Scroll indicator */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          className="absolute -bottom-40 left-1/2 -translate-x-1/2 hidden md:block"
        >
          <div className="w-5 h-9 border-2 border-gray-300 rounded-full flex justify-center">
            <motion.div 
              animate={{ 
                y: [0, 12, 0],
              }}
              transition={{ 
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="w-1 h-2 bg-[#12AF09] rounded-full mt-2"
            />
          </div>
        </motion.div>
      </motion.div>
    </motion.section>
      <Helmet>
        <meta charset="UTF-8" />
        <link rel="icon" href="/img/CML_LOGO.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Chain Magician Lab - Your one-stop solution for all software requirements. We specialize in blockchain development, including Ethereum development and smart contracts. Our mobile application services cover e-commerce apps, gaming apps, Web3 apps, and more. We also provide custom software solutions tailored to your business needs, along with decentralized application development and secure, scalable software solutions."
        />
        <title>
          Chain Magician Lab | Blockchain, Mobile & Custom Software Development
        </title>
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.chainmagicianlab.com/" />
        <meta
          property="og:title"
          content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
        />
        <meta
          property="og:description"
          content="Chain Magician Lab offers high-quality blockchain development, mobile app creation including e-commerce, gaming, and Web3 apps, and custom software solutions to meet your business needs."
        />
        <meta
          property="og:image"
          content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
        />
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.chainmagicianlab.com/"
        />
        <meta
          property="twitter:title"
          content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
        />
        <meta
          property="twitter:description"
          content="Chain Magician Lab provides comprehensive software solutions including blockchain development, mobile apps (e-commerce, gaming, Web3), custom software, decentralized applications, and smart contracts."
        />
        <meta
          property="twitter:image:alt"
          content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
        />
        <link rel="canonical" href="https://www.chainmagicianlab.com/" />
        <meta
          name="keywords"
          content="Blockchain development, Blockchain development company in India, Best blockchain company, Ethereum development services, Smart contract development, Smart contract developers India, dApp development company, Decentralized application development, Crypto exchange development India, Centralized exchange (CEX) development, Decentralized exchange (DEX) development, DEX aggregator platform, DEX liquidity pools, DEX security audits, DEX smart contracts, Cross-chain DEX development, Crypto arbitrage trading, Yield farming platform development, DeFi development company, DeFi staking platforms, DeFi lending protocols, DeFi token development, Cryptocurrency development, Crypto coin development, Crypto wallet development, Mobile crypto wallets, Web crypto wallets, Custodial and non-custodial wallets, ICO development company, STO development company, Token development services, Top token development company India, ERC-20 token development, BEP-20 token development, NFT token development, NFT marketplace development India, NFT smart contract solutions, NFT game development, Play-to-earn game development, NFT launchpad development, Tokenomics consulting, Token audit services, Token liquidity management, Token sale strategy, Token staking platform, Token governance models, Web3 integration company, Web3 application development, Web3 wallets, Web3 projects, Web3 APIs, Web3 infrastructure solutions, Web3 scalability, Web3 consulting India, Decentralized web solutions, DAO development services, Metaverse development company, Blockchain in healthcare India, Blockchain in supply chain India, Blockchain in fintech India, Blockchain consulting services, Blockchain architecture design, Blockchain protocol development, Blockchain auditing company, Blockchain security testing, Private blockchain development, Hyperledger development, Enterprise blockchain solutions, Blockchain IoT integration, AI and blockchain solutions, MLM software development company India, Best MLM software company, MLM compensation plans, Binary MLM plan software, Matrix MLM plan development, Unilevel MLM plan, Hybrid MLM software, Forced matrix MLM, MLM income calculator India, MLM business model solutions, MLM software features, MLM strategy consulting, MLM apps development, MLM software with blockchain, MLM company reviews India, Custom MLM software solutions, Mobile app development services, iOS app development India, Android app development company, Cross-platform mobile apps, Native app development services, Enterprise mobile app development, Mobile app UI/UX design, App store optimization, Mobile app testing services, Mobile app marketing, Mobile app maintenance, App deployment services, Custom mobile application solutions, Custom software development, Software development company in India, Enterprise software development, SaaS development company, PaaS development, Cloud software solutions, Software consulting India, Software modernization services, Bespoke software development, Software integration solutions, E-commerce website development India, Shopify development company India, Magento development, WooCommerce development, Custom e-commerce app development, Multi-vendor marketplace India, Online store development, E-commerce strategy consulting, E-commerce SEO services, Gaming app development company, Unity game development India, Unreal Engine game development, VR game development, AR game development, 2D game development, 3D game development, Multiplayer game apps, Educational game apps, Casual game development, Indie game development, Game monetization strategy, Blockchain gaming solutions, Play-to-earn game apps, Web3 gaming platforms, Crypto game development, Best blockchain consulting company India, Top blockchain companies in India, Best token development services, Crypto exchange developers India, Web3 developers India, Mobile app developers India, Custom software company India, Blockchain startup solutions, Token launch services, ICO launch company India.
"
        ></meta>
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Chain Magician Lab",
  "url": "https://www.chainmagicianlab.com",
  "logo": "https://www.chainmagicianlab.com/img/CML_LOGO.png",
  "tagline": "Magic in every line of software.",
  "description": "Chain Magician Lab specializes in blockchain development, Web3 integration, custom software, mobile apps, ecommerce apps, gaming apps, AI, and IoT solutions. We deliver innovative technology with strong expertise and nation-first vision.",
  "founder": {
    "@type": "Person",
    "name": "Anmol",
    "jobTitle": "Founder"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+91-6393561379",
      "contactType": "customer support",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    {
      "@type": "ContactPoint",
      "email": "chainmagicianlab@gmail.com",
      "contactType": "sales",
      "areaServed": "IN"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "India"
  },
  "sameAs": [
    "https://www.linkedin.com/company/chain-magician-lab",
    "https://twitter.com/chainmagicianlab",
    "https://t.me/decryptcoders"
  ],
  "makesOffer": [
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Blockchain Development",
        "description": "End-to-end blockchain solutions, custom smart contracts, and decentralized applications."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Web3 Integration",
        "description": "Seamless wallet integration, dApps, NFT marketplaces, and DeFi solutions."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Custom Software Development",
        "description": "Bespoke software tailored for businesses across industries."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Mobile Application Development",
        "description": "iOS, Android, Flutter, and React Native apps with modern UI/UX."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Ecommerce App Development",
        "description": "Secure and scalable ecommerce applications with payment integration."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Gaming Application Development",
        "description": "High-performance game development with Web3 and traditional support."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "AI & Machine Learning Solutions",
        "description": "AI-driven software, predictive analytics, and intelligent automation."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "IoT Solutions",
        "description": "Smart IoT development with focus on industrial and defense applications."
      }
    }
  ]
}
`}
        </script>
      </Helmet>

      {/* <Services /> */}
    </>
  );
}
